module.exports = __webpack_public_path__ + "img/map_6.b88bf932.png";